document.addEventListener("DOMContentLoaded", () => {
  let emailFill = false;
  let languageFill = false;
  let checkboxFill = false;
  const submitButton = document.querySelector(".subscribe-form__button");
  const emailField = document.querySelector('input[name="contact[email]"]');
  const languageField = document.querySelector(
    ".subscribe-form__selector-text"
  );
  const checkboxField = document.querySelector(".subscribe-form__checkbox");

  const disableButton = () => {
    if (submitButton) {
      submitButton.removeAttribute("type");
    }
  };

  const tryToEnableButton = () => {
    if (submitButton && emailFill && languageFill && checkboxFill) {
      submitButton.type = "submit";
    }
  };

  disableButton();

  if (checkboxField) {
    checkboxField.addEventListener("change", (e) => {
      if (e.target.checked) {
        checkboxFill = true;
        tryToEnableButton();
      } else {
        checkboxFill = false;
        disableButton();
      }
    });
  }

  if (emailField) {
    emailField.addEventListener("input", () => {
      if (emailField.value.trim() !== "" && emailField.checkValidity()) {
        emailFill = true;
        tryToEnableButton();
      } else {
        emailFill = false;
        disableButton();
      }
    });
  }

  if (languageField) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "childList" ||
          mutation.type === "characterData"
        ) {
          const isPlaceholder = languageField.classList.contains(
            "subscribe-form__selector-text--placeholder"
          );

          if (!isPlaceholder && languageField.textContent.trim() !== "") {
            languageFill = true;
            tryToEnableButton();
          } else {
            languageFill = false;
            disableButton();
          }
        }
      });
    });

    observer.observe(languageField, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
});
